<p-confirmDialog
  [appendTo]="'body'"
  header="Confirmation"
  icon="pi pi-exclamation-triangle"></p-confirmDialog>

<div class="col-lg-12">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span
        class="d-flex justify-content-between align-items-center p-2 mb-2 globalborder-btm-header"
        [ngClass]="isModal ? '' : 'm-2'">
        <span class="col-auto">
          <h2 class="mb-0">
            <ng-container *ngIf="isValidSamplePONumber"
              >Sample PO #
            </ng-container>
            <ng-container *ngIf="isValidSamplePONumber"
              >{{ samplePONumber }} -
            </ng-container>
            <span class="mx-1">{{ vendor?.vendorOrganizationNameD365 }}</span>
            <!-- <jni-spinner *ngIf="showSmallLoader"></jni-spinner> -->
          </h2>
        </span>

        <span class="col-auto">
          <ng-container
            *ngIf="purchaseOrderHeader?.isnetInForeignCurrencyStatus">
            PO Total :
            <b class="px-2">{{ netConversionTotalValue | currency: "USD" }}</b>
            <i class="icon-arrow-reverse"></i>
            <b class="px-2">{{
              total
                | currency
                  : getCurrencyConvertionCode(
                      purchaseOrderHeader?.currencyCodeD365 || ""
                    )
            }}</b>
          </ng-container>

          <a class="col-auto">
            Status :
            <b class="px-2">{{ purchaseOrderHeader?.status | titlecase }}</b>
          </a>
        </span>

        <span class="d-flex gap-2 customizefilter-btn">
          <div class="samplepo-panel ml-auto d-flex justify-content-between">
            <div
              class="ms-3 nav-link p-0 d-flex align-items-center"
              *ngIf="
                userRole === enumUserRole.Admin &&
                purchaseOrderHeader?.status === 'Draft'
              ">
              <i class="icon-Delete me-2"></i>
              <a class="link" (click)="deletePurchaseOrder()">Delete</a>
            </div>
            <div class="ms-3 nav-link p-0 d-flex align-items-center">
              <i class="icon-Copy me-2"></i>
              <!-- <a class="link" (click)="onCopyHeader()">Copy</a> -->
              <a class="link" (click)="copyCurrentHeader()"
                ><i class="pi pi-clone"></i> Copy</a
              >
            </div>
            <div class="ms-3 nav-link p-0 d-flex align-items-center">
              <i class="icon-Edit me-2"></i>
              <a class="link" (click)="onEditSamplePo(false)"
                ><i class="pi pi-pen-to-square"></i> Edit</a
              >
            </div>
            <!-- <div class="ms-3 nav-link p-0 d-flex align-items-center">
        <i class="icon-Add me-2"></i>
        <a class="link" (click)="addSamplePORedirect()">New</a>
      </div> -->

            <!-- <div  [hidden]="!isStatusSubmitted()" class="ms-3 nav-link p-0 d-flex align-items-center">
        <i [hidden]="!isStatusSubmitted()" class="icon-BCledger me-2"></i>
        <a [hidden]="!isStatusSubmitted()" class="link" (click)="redirectToPoEmail()">Email</a>
      </div> -->

            <div
              class="ms-3 nav-link p-0 d-flex align-items-center"
              [hidden]="!isStatusSubmitted()">
              <i class="icon-eye me-2" [hidden]="!isStatusSubmitted()"></i>
              <a
                class="link"
                (click)="redirectToPoEmail()"
                [hidden]="!isStatusSubmitted()"
                >View Sample PO</a
              >
            </div>
            <div class="dropdown ms-3" ngbDropdown>
              <a
                ngbDropdownToggle
                class="d-flex align-items-center justify-content-center">
                <i class="pi pi-ellipsis-v"></i>
              </a>
              <ul ngbDropdownMenu class="dropdown-menu py-3 mt-1">
                <li>
                  <!-- <button
              class="dropdown-item"
              (click)="onSave()"
              [disabled]="!samplePOSummaryForm.valid || updateSaveButtonStatus"
            >
              save
            </button> -->
                </li>
              </ul>
            </div>
          </div>
          <span
            class="cross-border"
            *ngIf="isModal"
            (click)="onCloseModalEvent()"
            ><i class="pi pi-times"></i
          ></span>
        </span>
      </span>

      <div class="col-12 samplepo-sum adduser-container-hgt p-2">
        <form [formGroup]="samplePOSummaryForm">
          <div class="row" formGroupName="header">
            <div class="col-12 mb-3">
              <div class="gray-bg-rounded">
                <div class="row">
                  <div class="col mb-2">
                    <div class="form-group has-float-label">
                      <label class="form-label">Job name</label>
                      <input
                        pInputText
                        jniAutoCompleteBlocker
                        type="text"
                        class="form-control"
                        [value]="purchaseOrderHeader?.jobNameD365"
                        formControlName="jobNameD365" />
                    </div>
                  </div>
                  <div class="col mb-2 d-flex align-items-center">
                    <div class="form-group has-float-label me-2 date-field">
                      <!-- <input pInputText 
            jniAutoCompleteBlocker
            [value]="
              purchaseOrderHeader?.expectedStoreAvailableSalesDateD365
                | date: 'yyyy-MM-dd'
            "
            [min]="shipDateCurrentdate | date: 'yyyy-MM-dd'"
            id="shipdate"
            name="shipdate"
            [disabled]="disabledShipAndInHandDate"
            class="form-control"
            (change)="onShipDateSelection($event)"
            onfocus="(this.type='date')"
            onblur="if(!this.value) this.type='text'"
          /> -->
                      <label class="form-label">Ship date</label>
                      <p-datePicker
                        jniAutoCompleteBlocker
                        inputId="basic"
                        class="date-input"
                        (onSelect)="onShipDateSelection($event)"
                        formControlName="expectedStoreAvailableSalesDateD365"
                        [minDate]="shipDateCurrentdate"
                        [showOtherMonths]="true"
                        [selectOtherMonths]="true"></p-datePicker>
                    </div>
                    <div class="form-group has-float-label me-2 date-field">
                      <!-- <input pInputText 
            jniAutoCompleteBlocker
            [value]="
              purchaseOrderHeader?.expectedStoreReceiptDateD365
                | date: 'yyyy-MM-dd'
            "
            [min]="inHandDateCurrentdate | date: 'yyyy-MM-dd'"
            id="inhandsdate"
            name="inhandsdate"
            [disabled]="disabledShipAndInHandDate"
            class="form-control"
            (change)="onInHandDateSelection($event)"
            onfocus="(this.type='date')"
            onblur="if(!this.value) this.type='text'"
          /> -->
                      <label class="form-label"
                        >In Hands date<span class="madatory-field"
                          >*</span
                        ></label
                      >
                      <p-datePicker
                        jniAutoCompleteBlocker
                        inputId="basic"
                        class="date-input"
                        (onSelect)="onInHandDateSelection($event)"
                        formControlName="expectedStoreReceiptDateD365"
                        (onBlur)="logValidationErrors()"
                        [ngClass]="{
                          'has-error':
                            formErrors['expectedStoreReceiptDateD365'],
                        }"
                        [minDate]="inHandDateCurrentdate"
                        [showOtherMonths]="true"
                        [selectOtherMonths]="true"></p-datePicker>

                      <span
                        class="error-msg"
                        *ngIf="formErrors['expectedStoreReceiptDateD365']">
                        {{ formErrors["expectedStoreReceiptDateD365"] }}
                      </span>
                    </div>
                    <div class="form-check d-flex gap-2 pt-2 mt-4">
                      <input
                        pInputText
                        type="checkbox"
                        [checked]="
                          purchaseOrderHeader?.firm?.toLowerCase() === 'yes'
                            ? true
                            : false
                        "
                        class="form-check-input m-0 no-bg"
                        formControlName="rsmFirmD365"
                        [disabled]="true" />
                      <label class="firm">Firm</label>
                    </div>
                  </div>
                  <div
                    class="col mb-2 client-prospect has-dropdown-menu"
                    #client>
                    <div
                      class="form-group has-float-label"
                      id="dropdownBasic3"
                      (click)="onClientRedirection()">
                      <label class="form-label">client/prospect</label>
                      <input
                        pInputText
                        jniAutoCompleteBlocker
                        type="text"
                        id="clientprospect"
                        name="clientprospect"
                        class="form-control"
                        formControlName="clientProspectNumber"
                        (input)="searchClient$.next($any($event.target).value)"
                        (keyup)="
                          onClientSearchOpenToggle($event, clientDropdown)
                        " />

                      <p-popover
                        #clientDropdown
                        aria-labelledby="dropdownBasic3">
                        <div style="height: 200px">
                          <p-table
                            #dt
                            [value]="clientLists"
                            styleClass="p-datatable-customers po-small"
                            [rowHover]="true"
                            [rows]="10"
                            [showCurrentPageReport]="true"
                            [rowsPerPageOptions]="[10, 25, 50]"
                            [paginator]="false"
                            [filterDelay]="0">
                            <ng-template pTemplate="header">
                              <tr>
                                <th class="name">Client</th>
                                <th class="vaccount">Account</th>
                                <th class="phone">Street</th>
                                <th class="city">City</th>
                                <th class="state">State</th>
                                <th class="country">Last order date</th>
                              </tr>
                            </ng-template>
                            <ng-template
                              pTemplate="body"
                              let-clientList
                              let-rowIndex="rowIndex">
                              <tr
                                class="p-selectable-row mousepointer"
                                (click)="
                                  onClientSelection(clientList, clientDropdown)
                                ">
                                <td class="name mousepointer">
                                  {{ clientList.organizationNameD365 }}
                                </td>
                                <td class="vaccount mousepointer">
                                  {{ clientList.clientAccount }}
                                </td>
                                <td class="sname mousepointer">
                                  {{ clientList.street }}
                                </td>
                                <td class="city mousepointer">
                                  {{ clientList.city }}
                                </td>
                                <td class="state mousepointer">
                                  {{ clientList.state }}
                                </td>
                                <td class="country mousepointer">
                                  {{
                                    clientList.lastOrderDate
                                      | date: "yyyy-MM-dd"
                                  }}
                                </td>
                              </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage">
                              <tr>
                                <td colspan="20">No client found.</td>
                              </tr>
                            </ng-template>
                          </p-table>
                        </div>
                      </p-popover>
                    </div>
                  </div>
                  <div class="col mb-2">
                    <div class="form-group has-float-label">
                      <label class="form-label">Branding Consultant</label>
                      <select pInputText class="form-select">
                        <option>
                          {{ samplePOSummary.brandingConsultant }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col mb-2">
                    <div class="form-group has-float-label">
                      <label class="form-label">Accounts coordinator</label>
                      <select pInputText class="form-select" disabled>
                        <option>
                          {{ samplePOSummary.accountCoordinator }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- <div
            class="collapse-section invert border-0 mb-minus-2 mb-2 mt-2 d-flex justify-content-end">
            <a
              class="btn-collapse"
              (click)="onToggle()"
              [ngClass]="{ active: collapseStatus }"
              >{{ collapseHeading }} </a>
          </div> -->
          <div class="col-12 p-1">
            <div class="m-2 collaspe-padding">
              <p-panel
                class="row collapseable"
                [toggleable]="true"
                [collapsed]="collapseStatus"
                (onBeforeToggle)="onToggle()"
                [ngClass]="{ active: collapseStatus }"
                [expandIcon]="'pi pi-angle-double-up'"
                [collapseIcon]="'pi pi-angle-double-down'"
                [iconPos]="'end'">
                <ng-template #icons>
                  <a (click)="onToggle()">{{ collapseHeading }}</a>
                </ng-template>
                <div class="col-12">
                  <div class="d-flex gap-3">
                    <div class="col-lg">
                      <div class="gray-bg-rounded">
                        <h3 class="mb-2">Vendor</h3>
                        <div class="form-group has-float-label mb-2">
                          <label class="form-label">Vendor name</label>
                          <input
                            pInputText
                            jniAutoCompleteBlocker
                            type="text"
                            class="form-control"
                            [value]="vendor?.vendorOrganizationNameD365"
                            disabled />
                        </div>
                        <div
                          class="form-group has-float-label mb-2"
                          (click)="
                            onvendorRedirection(
                              vendor?.vendorAccountNumberD365 || ''
                            )
                          ">
                          <label class="form-label">Vendor account</label>
                          <input
                            pInputText
                            jniAutoCompleteBlocker
                            type="text"
                            class="form-control has-link"
                            [value]="vendor?.vendorAccountNumberD365"
                            disabled />
                        </div>
                        <div
                          class="form-group has-float-label mb-2 hideincollapse">
                          <label class="form-label">Vendor address</label>
                          <textarea
                            rows="5"
                            pInputText
                            jniAutoCompleteBlocker
                            [value]="primaryVendorAddress?.addressD365"
                            class="form-control"
                            disabled></textarea>
                        </div>
                        <div
                          class="form-group has-float-label mb-2 hideincollapse">
                          <label class="form-label">Phone number</label>
                          <input
                            pInputText
                            jniAutoCompleteBlocker
                            type="text"
                            class="form-control"
                            [value]="vendorPhone ? vendorPhone : ''"
                            disabled />
                        </div>
                        <div
                          class="form-group has-float-label mb-2 hideincollapse">
                          <label class="form-label">Email Address</label>
                          <input
                            pInputText
                            jniAutoCompleteBlocker
                            type="email"
                            class="form-control"
                            [value]="vendorEmail ? vendorEmail : ''"
                            disabled />
                        </div>
                      </div>
                    </div>
                    <div class="col-lg">
                      <div class="gray-bg-rounded">
                        <h3 class="mb-2">Ship to</h3>
                        <jni-samplepo-ship-to-address
                          #shipTo
                          [parent]="samplePOSummaryForm"
                          [formgroupName]="'addressInformation'"
                          [deliveryAddress]="deliveryAddress"
                          [countryRegionList]="countryRegionList"
                          [customerBillToObject]="customerBillToObject"
                          [countryRegionSelectedId]="countryRegionIdD365"
                          [formErrors]="formErrors"
                          [addressField]="addressField"
                          [showAddress]="showAddress"
                          [brandingConsultantObject]="brandingConsultantObject"
                          (validationErrorEvent)="logValidationErrors()"
                          [collapseStatus]="collapseStatus"
                          [attentionFieldStatus]="attentionFieldStatus"
                          [editHeaderStatus]="editHeaderStatus"
                          [samplePOSummary]="samplePOSummary">
                        </jni-samplepo-ship-to-address>
                      </div>
                    </div>
                    <div class="col-lg">
                      <div class="gray-bg-rounded" formGroupName="header">
                        <h3 class="mb-2">Details</h3>
                        <div class="form-group has-float-label mb-2">
                          <div class="form-group has-float-label">
                            <label class="form-label">Shipping Method</label>
                            <p-select
                              pInputText
                              [(ngModel)]="shippingMethod"
                              id="currency"
                              formControlName="deliveryModeIdD365"
                              [options]="shippingProductsList"
                              optionLabel="modeDescriptionD365"
                              optionValue="modeCodeD365"
                              [showClear]="true"
                              [filter]="true"
                              (onChange)="onShippingMethodSelect($event)">
                            </p-select>
                          </div>
                        </div>
                        <div class="form-group has-float-label mb-2">
                          <label class="form-label">Account #</label>
                          <input
                            pInputText
                            jniAutoCompleteBlocker
                            type="text"
                            class="form-control"
                            [value]="purchaseOrderHeader?.accountNumber"
                            formControlName="accountNumber" />
                        </div>
                        <div
                          class="form-group has-float-label mb-2 d-flex align-items-center hideincollapseflex">
                          <input
                            pInputText
                            class="form-check-input me-2 mt-4"
                            type="checkbox"
                            [checked]="
                              purchaseOrderHeader?.isnetInForeignCurrencyStatus
                            "
                            [disabled]="true" />
                          <div class="form-group has-float-label flex-grow-1">
                            <label class="form-label"
                              >Net in Foreign Currency</label
                            >
                            <select class="form-select" pInputText disabled>
                              <option>
                                {{ purchaseOrderHeader?.currencyCodeD365 }}
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <ng-container
                        *ngIf="
                          (line &&
                            createLine === false &&
                            addLineType === 'create') ||
                          (addLineType === 'edit' && !isLineEdit)
                        ">
                        <div class="col-lg">
                          <div class="gray-bg-rounded">
                            <div class="samplepo-details pb-0 mb-2">
                              <div class="row">
                                <div class="col">
                                  <h3 class="mb-2">
                                    Line #
                                    {{ line?.lineNumberD365 }}
                                  </h3>
                                </div>
                              </div>
                              <div class="bg-grey-section">
                                <div class="row">
                                  <div class="col mb-2">
                                    <label class="title"
                                      >SKU required:<br />
                                      {{ line?.externalItemNumberD365 }}</label
                                    >
                                  </div>
                                  <div class="col mb-2">
                                    <label class="title"
                                      >Freight:<br />
                                      {{
                                        purchaseOrderHeader?.deliveryModeIdD365
                                      }}</label
                                    >
                                  </div>
                                  <div class="col mb-2">
                                    <label class="title"
                                      >Ship:<br />
                                      {{
                                        line?.requestedShippingDateD365
                                          | date: "MM/dd/yyyy"
                                      }}</label
                                    >
                                  </div>
                                  <div class="col mb-2">
                                    <label class="title"
                                      >In Hands:<br />
                                      {{
                                        line?.requestedDeliveryDateD365
                                          | date: "MM/dd/yyyy"
                                      }}</label
                                    >
                                  </div>
                                </div>
                                <div class="row hideincollapseflex">
                                  <div class="col mb-2">
                                    <label class="title"
                                      >Quantity:<br />
                                      {{
                                        line?.orderedPurchaseQuantityD365
                                      }}</label
                                    >
                                  </div>
                                  <div class="col mb-2">
                                    <label class="title"
                                      >NET:<br />
                                      {{
                                        convertNumberToString(
                                          line?.purchasePriceD365 || 0
                                        )
                                          | currency
                                            : getCurrencyConvertionCode(
                                                purchaseOrderHeader?.currencyCodeD365 ||
                                                  ""
                                              )
                                      }}</label
                                    >
                                  </div>
                                  <div class="col mb-2">
                                    <label class="title"
                                      >Total NET: <br />{{
                                        line?.lineAmountD365
                                          | currency
                                            : getCurrencyConvertionCode(
                                                purchaseOrderHeader?.currencyCodeD365 ||
                                                  ""
                                              )
                                      }}</label
                                    >
                                  </div>
                                  <div class="col"></div>
                                </div>
                              </div>
                            </div>
                            <div class="row hideincollapseflex">
                              <div class="col-12 mb-2">
                                <div class="form-group has-float-label">
                                  <label class="form-label">Description</label>
                                  <textarea
                                    rows="5"
                                    pInputText
                                    jniAutoCompleteBlocker
                                    disabled
                                    placeholder=""
                                    class="form-control"
                                    [value]="
                                      line?.lineDescriptionD365
                                        ? line?.lineDescriptionD365
                                        : ''
                                    ">
                                  </textarea>
                                </div>
                              </div>
                              <div class="col-12 mb-2">
                                <div class="form-group has-float-label">
                                  <label class="form-label"
                                    >Factory Notes</label
                                  >
                                  <textarea
                                    pInputText
                                    rows="5"
                                    jniAutoCompleteBlocker
                                    disabled
                                    placeholder=""
                                    class="form-control"
                                    [value]="
                                      line?.factoryNotesD365
                                        ? line?.factoryNotesD365
                                        : ''
                                    ">
                                  </textarea>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </ng-container>

                      <jni-add-line
                        *ngIf="
                          createLine || (addLineType === 'edit' && isLineEdit)
                        "
                        [parent]="samplePOSummaryForm"
                        [currencyConversion]="currencyConversion"
                        [firmOneCheckBox]="
                          (addLineType === 'edit' &&
                            (line?.rsmFirmD365?.toLowerCase() === 'yes' ||
                              line?.rsmFirmD365?.toLowerCase() === 'true')) ||
                          (addLineType === 'create' &&
                            headerFirm.toLowerCase() === 'yes')
                            ? true
                            : false
                        "
                        [inHandDateOne]="inHandsDate"
                        [shipDateOne]="shippingDate"
                        [isSummary]="true"
                        [addLineType]="addLineType"
                        [lineNumber]="getMaxLineNumber()"
                        [currencyConversionStatus]="
                          purchaseOrderHeader?.isnetInForeignCurrencyStatus ||
                          false
                        "
                        [formErrors]="formErrors"
                        (validationEvent)="logValidationErrors()"
                        (showPositionDialogDescriptionEvent)="
                          showPositionDialogDescription($event)
                        "
                        (showPositionDialogFactoryEvent)="
                          showPositionDialogFactory($event)
                        "
                        [createNewLineTrigger]="createNewLineTrigger">
                      </jni-add-line>

                      <div
                        class="d-flex pt-5 justify-content-end mb-5 hideincollapseflex gap-3"
                        *ngIf="createLine || addLineType === 'edit'">
                        <!-- <button
                      type="button"
                      class="btn btn-secondary me-3"
                      (click)="cancel()">
                      Cancel
                    </button> -->
                        <!-- <button
                      type="button"
                      class="btn btn-primary"
                      (click)="onSave()"
                      [disabled]="
                        !samplePOSummaryForm.valid || updateSaveButtonStatus
                      "
                      *ngIf="!isLineEdit">
                      Save Header
                    </button> -->
                        <!-- <button
                      type="button"
                      [disabled]="!samplePOSummaryForm.valid"
                      class="btn btn-primary"
                      (click)="addSamplePoScreen()"
                      *ngIf="isLineEdit">
                      Save Line
                    </button> -->

                        <p-button
                          label=" Cancel"
                          (click)="cancel()"
                          variant="outlined"
                          severity="secondary" />

                        <p-button
                          label="Save Header"
                          (click)="onSave()"
                          [disabled]="
                            !samplePOSummaryForm.valid || updateSaveButtonStatus
                          "
                          *ngIf="!isLineEdit" />

                        <p-button
                          label="Save Line"
                          [disabled]="!samplePOSummaryForm.valid"
                          (click)="addSamplePoScreen()"
                          *ngIf="isLineEdit" />
                      </div>
                    </div>
                  </div>
                </div>
              </p-panel>
            </div>
          </div>
          <div class="gray-bg-rounded">
            <jni-line-items
              #linesComponent
              [parent]="samplePOSummaryForm"
              [purchaseOrderHeader]="purchaseOrderHeader"
              (lineSelected)="lineSelected($event)"
              (updateLine)="onEditSamplePo(true)"
              (createLine)="createNewLine($event)"
              (dropEvent)="onDelete($event)"
              (copyEvent)="copyLines($event)"
              [purchaseOrderLineList]="purchaseOrderLineList"
              [currencyConversion]="currencyConversion"
              [releasedProductsList]="releasedProductsList"
              [purchaseOrderStatus]="purchaseOrderStatus"
              (gridSaveAndUpdateEvent)="saveAndUpdateSamplepoGrid($event)"
              (refrestDataEvent)="refreshGrid()"
              (copyLinesEvent)="showCopyLineModalDialog($event)"
              (printLineEvent)="printLine()">
            </jni-line-items>
          </div>
        </form>
      </div>
    </p-card>
  </div>
</div>

<jni-stock-phrases
  #stockPhraseDescription
  [flag]="'description'"
  [displayPosition]="displayPositionDescription"
  [position]="position"
  [displayModal]="displayModal"
  [customerCheckbox]="customerCheckbox"
  [vendorCheckbox]="vendorCheckbox"
  [customerId]="customerId"
  [vendorAccountNumber]="vendorAccountNumber"
  (closeMainModalEvent)="closePositionDialogDescription()"
  (notesAndFactEvent)="getDescription($event)"></jni-stock-phrases>

<jni-stock-phrases
  #stockPhraseFactory
  [flag]="'factory'"
  [displayPosition]="displayPositionFactory"
  [position]="position"
  [displayModal]="displayModal"
  [customerCheckbox]="customerCheckbox"
  [vendorCheckbox]="vendorCheckbox"
  [customerId]="customerId"
  [vendorAccountNumber]="vendorAccountNumber"
  (closeMainModalEvent)="closePositionDialogFactory()"
  (notesAndFactEvent)="getFactory($event)"></jni-stock-phrases>

<jni-samplepo-copy-lines
  #copyline
  [displayModal]="displayCopyLineModel"
  [samplePONumber]="samplePONumber"
  (refreshGridEvent)="refreshGrid()"
  (closeDialogEvent)="closeModalDialog()">
</jni-samplepo-copy-lines>

<jni-samplepo-copy-header
  #copyheader
  [displayModal]="displayCopyHeaderModel"
  [samplePONumber]="samplePONumber"
  (refreshGridEvent)="refreshGrid()"
  (closeDialogEvent)="closeHeaderModalDialog()"
  (samplePORedirect)="samplePORedirect($event)">
</jni-samplepo-copy-header>

<jni-modal-stacker
  *ngIf="vendorDisplayModal"
  [displayModal]="vendorDisplayModal"
  (closeEvent)="closeModal()">
  <h1 class="panelHeading">Vendor Summary</h1>
  <div class="panelBody">
    <jni-vendor-summary
      [vendorIdFromModal]="vendorAccountNumber"
      (closeModalOnOpenLinesEvent)="closeModalOnOpenLines($event)"
      (closeModalOnOpenPOEvent)="closeModalOnOpenPO($event)"
      (scrollHiddenStatus)="addScollHiddenClass()"
      (emitcloseVendorModalStacker)="closeModal()"></jni-vendor-summary>
  </div>
</jni-modal-stacker>

<jni-modal-stacker
  *ngIf="displayModalViewSamplePo"
  [displayModal]="displayModalViewSamplePo"
  (closeEvent)="closeModalForViewSamplePo()"
  class="modal-header-sticky">
  <h1 class="panelHeading mt-5"></h1>
  <div class="panelBody">
    <jni-po-email
      [poNumberParams]="samplePONumber"
      (closeModalEvent)="closeModalForViewSamplePo()"></jni-po-email>
  </div>
</jni-modal-stacker>
